import React from 'react';

const shell = {
  minHeight: '100vh',
  background: '#0f1419',
  color: '#e8eaed',
  fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
  boxSizing: 'border-box',
};

export default function ConfigGuard({ children }) {
  if (process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY) {
    return children;
  }

  return (
    <div style={shell}>
      <div style={{ maxWidth: 440, textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.35rem', margin: '0 0 12px' }}>App not configured</h1>
        <p style={{ color: '#9aa0a6', lineHeight: 1.6, margin: '0 0 8px' }}>
          Missing Supabase environment variables. Set{' '}
          <code style={{ color: '#0d7377' }}>REACT_APP_SUPABASE_URL</code> and{' '}
          <code style={{ color: '#0d7377' }}>REACT_APP_SUPABASE_ANON_KEY</code> in your hosting
          provider, then redeploy.
        </p>
      </div>
    </div>
  );
}
